import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output
} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SaUserFilter} from "./saUser.filter";
import { debounceTime } from 'rxjs/operators';
import {SettingsPersistenceService} from "../../services/settings-persistence.service";
import {MatLegacyCheckboxChange} from "@angular/material/legacy-checkbox";
import {AlertService} from "../../services/alert.service";

@Component({
  selector: 'micro-saUsers',
  templateUrl: './saUsers.component.html'
})
export class SaUsersComponent implements OnInit, OnDestroy, OnChanges  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SaUserFilter = new SaUserFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  regionId:any;

  @Input()
  selectionMode:string = 'multi';

  pageSettings: SettingsPersistenceService;

  selectedUserIds: string[] = [];


  constructor(public auth:AuthService,
              private env:EnvService,
              private alertService:AlertService,
              private http:HttpClient) {
  }

  ngOnInit() {
    if (this.regionId) {
      this.filter.regionId = this.regionId;
    }

    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.sausers");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(this.regionId)
      .init();

    if (this.filter.hasService === undefined) {
      this.filter.hasService = 'true';
    }

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      if (change.prop === 'hasService') {
        this.selectedUserIds = [];
      }
      this.reload();
    });
    this.reloadDebouncer.pipe(debounceTime(50)).subscribe(change => {
      this.reloadDebounced();
    });

    // this.reload();
  }

  reload() {
    this.reloadDebouncer.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let anyChanges = false;
    for (let prop in changes) {
      if (prop === 'companyId' && changes[prop].currentValue !== changes[prop].previousValue) {
        this.filter.companyId = changes[prop].currentValue;
        anyChanges = anyChanges || true;
      }
      if (prop === 'departmentId' && changes[prop].currentValue !== changes[prop].previousValue) {
        this.filter.departmentId = changes[prop].currentValue;
        anyChanges = anyChanges || true;
      }
      if (prop === 'regionId' && changes[prop].currentValue !== changes[prop].previousValue) {
        this.filter.regionId = changes[prop].currentValue;
        anyChanges = anyChanges || true;
      }
    }
    if (anyChanges) this.reload()
  }

  ngOnDestroy() {
  }

  reloadDebounced() {
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      .set("service", "SITE_ACCESS");

    this.http.get(`${this.env.e.url}/auth/users`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.length = page.totalElements;
      }
    );
  }

  protected onSelectUser(chg: MatLegacyCheckboxChange) {
    if (chg.checked) {
      this.selectedUserIds.push(chg.source.value);
    } else {
      this.selectedUserIds = this.selectedUserIds.filter(id => id !== chg.source.value);
    }

  }

  protected revokeSecureAccess() {
    let params:HttpParams = new HttpParams().set("service", "SITE_ACCESS");

    this.http.post(`${this.env.e.url}/access/saContacts/users/removeService`, this.selectedUserIds, {params: params}).subscribe(
      () => {
        this.alertService.info(`Secure Access revoked for ${this.selectedUserIds.length} users.`);
        this.selectedUserIds = [];
        this.reloadDebounced();
      }
    );
  }

  protected enableSecureAccess() {
    let params:HttpParams = new HttpParams().set("service", "SITE_ACCESS");

    this.http.post(`${this.env.e.url}/access/saContacts/users/addService`, this.selectedUserIds, {params: params}).subscribe(
      () => {
        this.alertService.info(`Secure Access enabled for ${this.selectedUserIds.length} users.`);
        this.selectedUserIds = [];
        this.reloadDebounced();
      }
    );
  }
}
